module.exports = __webpack_public_path__ + "static/media/Groente.d05fe924.svg";